import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// import Texts from '../Messages/Texts'
import ConversationsWrapper from '../Messages/ConversationsWrapper'
import converse from '../Messages/converse'
import Calls from '../Calls'
import Appointments from '../Appointments'
import Notes from '../Notes'
import css from './tabs.css'
import { getPatientNotes } from '../../../state/actions/selected-patient'

const Texts = converse(ConversationsWrapper, {
  messagesType: 'text',
  displayName: 'Texts',
})

const Emails = converse(ConversationsWrapper, {
  messagesType: 'email',
  displayName: 'Emails',
})

const tabs = [
  { name: 'Appointments', component: Appointments },
  { name: 'Notes', component: Notes },
  { name: 'Texts', component: Texts },
  { name: 'Emails', component: Emails },
  { name: 'Calls', component: Calls },
]

class Tabs extends Component {
  static propTypes = {
    patientId: PropTypes.string.isRequired,
    getNotes: PropTypes.func.isRequired,
    hasScreenPop: PropTypes.bool.isRequired,
    messageSettingsById: PropTypes.object.isRequired,
    templateSettings: PropTypes.array.isRequired,
  }

  state = {
    activeTabIndex: 0,
  }

  componentWillMount() {
    const { getNotes, patientId } = this.props
    getNotes(patientId).then(notes => {
      this.setState({
        activeTabIndex: notes.length > 0 ? 1 : 0,
      })
    })
  }

  handleTabClick = (tabId, e) => {
    this.setState({
      activeTabIndex: tabId,
    })
    e.target.blur()
  }

  render() {
    const { activeTabIndex } = this.state
    const filteredTabs = this.props.hasScreenPop
      ? tabs
      : tabs.filter(tab => tab.name !== 'Calls')
    const TabContent = filteredTabs[activeTabIndex].component

    return (
      <div className={css.rightPanel}>
        <div className={css.panelTabs}>
          {filteredTabs.map((tab, index) => (
            <div
              key={tab.name}
              role="menuitem"
              tabIndex="0 "
              className={`${css.tab} ${
                index === activeTabIndex ? css.active : ''
              }`}
              onClick={e => this.handleTabClick(index, e)}
            >
              {tab.name}
            </div>
          ))}
        </div>
        <div className={css.tabContent}>
          <TabContent
            messageSettingsById={this.props.messageSettingsById}
            patientId={this.props.patientId}
            templateSettings={this.props.templateSettings}
          />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getNotes: patientId => dispatch(getPatientNotes(patientId)),
})

export default connect(null, mapDispatchToProps)(Tabs)



// WEBPACK FOOTER //
// ./src/components/PatientPage/Tabs/index.js